import { connect } from 'react-redux';
import {
  modal as modalActions,
  triggerBaselineUpdate,
  triggerJobFromId
} from '../actions';
import PropTypes from 'prop-types';
import { owners } from '../helpers/modals';
import { modalReducer } from '../reducers';
import { scenarios } from '../helpers';
import AcknowledgeBaselineUpdateModalComponent
  from '../Components/AcknowledgeBaselineUpdateModalComponent';

export const mapStateToProps = (state) => {
  const visible = modalReducer.getModalVisibility(
    state, owners.acknowledgeBaselineUpdate);
  const modalInfo = modalReducer.
    getModalInfoByOwner(
      state, owners.acknowledgeBaselineUpdate);
  const title = 'Confirm Baseline Update';
  const confirmText = 'Confirm';
  const cancelText = 'Cancel';
  const bodyText = 'This will update the baseline to the case ' +
    'currently selected for NCF and CCF';
  const checkboxText = 'Retrigger Scenario';

  return {
    visible,
    title,
    confirmText,
    cancelText,
    bodyText,
    checkboxText,
    eventProps: modalInfo,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onCancel: () => {
      dispatch(modalActions.showAcknowledgeBaselineUpdateModal(false));
    },
    onCheckboxChange: retrigger =>
      dispatch(modalActions.setBaselineUpdateRetriggerOption(retrigger)),
    onConfirm: (eventProps) => {
      dispatch(triggerBaselineUpdate(
        scenarios.getArtifactPlatform(eventProps.scenario.name),
        scenarios.getConvertedArtifactScenarioName(eventProps.scenario.name),
        eventProps.title.match(/\d+/g)[0]));
      if (eventProps.retrigger) {
        dispatch(triggerJobFromId(eventProps.scenario.runner));
      }
      dispatch(modalActions.showAcknowledgeBaselineUpdateModal(false)); }
  };
};

const AcknowledgeBaselineUpdateModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AcknowledgeBaselineUpdateModalComponent);

AcknowledgeBaselineUpdateModalContainer.propTypes = {
  visible: PropTypes.func,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  bodyText: PropTypes.string,
  checkboxText: PropTypes.string,
  modalInfo: PropTypes.object,
};

export default AcknowledgeBaselineUpdateModalContainer;


// WEBPACK FOOTER //
// src/Containers/AcknowledgeBaselineUpdateModalContainer.jsx